import cn from 'classnames';
import { Tag } from 'primereact/tag';

import styles from '../Tag.module.scss';

interface SuccessTagProps {
  message: string;
  className?: string;
}

export function SuccessTag({ message, className }: SuccessTagProps) {
  return <Tag className={cn(styles.successTag, className)} value={message} severity='success' />;
}
